export const env = {
  DEV: {
    API_URL: `https://api.lo.nftydoor.com/dev`,
  },
  LOCAL: {
    API_URL: `https://api.lo.nftydoor.com/dev`,
  },
  FRANFG: {
    API_URL: `https://api.lo.nftydoor.com/dev-fg`,
  },
  GIUL: {
    API_URL: `https://api.lo.nftydoor.com/dev-guls`,
  },
  LU: {
    API_URL: `https://api.lo.nftydoor.com/dev-lu`,
  },
  PROD: {
    API_URL: `https://api.lo.nftydoor.com/prod`,
  },
  CUSTOM: {
    API_URL: `https://api.lo.nftydoor.com/dev-guls`,
  },
};

export const ENV = localStorage.getItem("currentEnvironment") ?? "DEV";

function getEnvVariable(key) {
  const isInProduction = process.env.REACT_APP_ENV === "prod";
  return env[isInProduction ? "PROD" : ENV][key];
}

export default getEnvVariable;
